import React from 'react'

export const Diamond = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
    {...props}
  >
    <g clip-path='url(#clip0_2875_63366)'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M17.9196 3C18.5821 3 19.1977 3.32768 19.5686 3.86822L19.6561 4.00772L22.9892 9.8407C23.4087 10.5749 23.3189 11.4871 22.7805 12.1237L22.6669 12.2472L13.3838 21.5303C12.9282 21.986 12.2084 22.0163 11.7175 21.6214L11.616 21.5303L2.3329 12.2472C1.73502 11.6493 1.58164 10.7456 1.9335 9.98977L2.01063 9.8407L5.34376 4.00772C5.67246 3.4325 6.2624 3.06058 6.91572 3.00676L7.08025 3H17.9196ZM7.79283 9.29289C7.40231 9.68342 7.40231 10.3166 7.79283 10.7071L11.6161 14.5303C12.1042 15.0185 12.8957 15.0185 13.3838 14.5303L17.207 10.7071C17.5976 10.3166 17.5976 9.68342 17.207 9.29289C16.8165 8.90237 16.1834 8.90237 15.7928 9.29289L12.4999 12.5858L9.20705 9.29289C8.81652 8.90237 8.18336 8.90237 7.79283 9.29289Z'
      />
    </g>
    <defs>
      <clipPath id='clip0_2875_63366'>
        <rect width='24' height='24' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
)
